import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as Sentry from "@sentry/browser";
import registerServiceWorker from "./registerServiceWorker";
import registerServiceWorkerForElectron from "./registerServiceWorkerForElectron";
import "./index.css";

startSentry();
ReactDOM.render(<App />, document.getElementById("root"));

function startSentry() {
  try {
    if (process.env.NODE_ENV === "production") {
      Sentry.init({
        dsn: window.SENTRY_DSN, 
        environment: window.SENTRY_ENV,
        release: window.SENTRY_REL
      });
    }
  } catch (error) {
    console.log("Init error Sentry service", error);
  }
}

function isElectron() {
  let userAgent = navigator.userAgent.toLowerCase();
  return userAgent.indexOf(" electron/") > -1;
}

if (isElectron()) {
  registerServiceWorkerForElectron();
} else {
  registerServiceWorker();
}



// WEBPACK FOOTER //
// ./src/index.js